import useJwt from '@/auth/jwt/useJwt'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import store from '@/store'

export const googleSignInEnabled = () => Boolean(process.env.VUE_APP_GOOGLE_CLIENT_ID)

const WELCOME_WINDOW_MS = 30 * 60 * 1000
const welcomeKey = userId => `yoc:welcome-seen:${userId}`

export const startSession = payload => {
  document.documentElement.style.setProperty('--secondary-custom', payload.secondary_color)
  document.documentElement.style.setProperty('--primary-custom', payload.primary_color)
  useJwt.setToken(payload.token)
  useJwt.setRefreshToken(payload.refresh_token)
  localStorage.setItem('userData', JSON.stringify(payload))
  store.commit('auth/setCurrentUser', payload)
  store.commit('legal/SET_REQUIREMENTS_CHECKED', true)
  return payload
}

export const shouldWelcome = userData => {
  if (userData?.role_name !== 'customer' || !userData.id || !userData.created_at) return false
  try {
    if (localStorage.getItem(welcomeKey(userData.id))) return false
  } catch (error) {
    return false
  }
  return Date.now() - new Date(userData.created_at).getTime() < WELCOME_WINDOW_MS
}

export const markWelcomeSeen = userId => {
  try {
    localStorage.setItem(welcomeKey(userId), '1')
  } catch (error) {
    return false
  }
  return true
}

export const landingRoute = userData => (shouldWelcome(userData) ? { name: 'welcome' } : getHomeRouteForLoggedInUser(userData))
